import { useEffect, useRef } from "react";

const useDragScroll = <E extends HTMLElement>({
  x,
  y,
}: {
  x?: boolean;
  y?: boolean;
}): React.RefObject<E> => {
  const scrollRef = useRef<E>(null);

  useEffect(() => {
    const r = scrollRef.current;
    if (!r) return;

    const handleMouseDown = (event: MouseEvent) => {
      const startX = event.clientX;
      const startY = event.clientY;

      const startScrollLeft = r.scrollLeft;
      const startScrollTop = r.scrollTop;

      const handleMouseMove = (event: MouseEvent) => {
        const deltaX = startX - event.clientX;
        const deltaY = startY - event.clientY;

        if (r) {
          if (x) r.scrollLeft = startScrollLeft + deltaX;
          if (y) r.scrollTop = startScrollTop + deltaY;
        }
      };

      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };

    r.addEventListener("mousedown", handleMouseDown);

    return () => {
      if (r) {
        r.removeEventListener("mousedown", handleMouseDown);
      }
    };
  }, [x, y]);

  return scrollRef;
};

export default useDragScroll;
